import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import BookListItem from '../books/components/BookListItem';

export const RecommendBookList = ({list, className=''})=>{
    const bookListElement = useMemo(()=>{
        
        return list.map((book, key)=>{    
            return (
                <li key={key}>
                    <Link to={`/${window.schoolCode}/book/${book.isbn}`} >
                        <BookListItem book={book} />
                    </Link>
                </li>
            );
        });
    }, [list]);

    if(list.length<=0) return <div className="no_data">추천 도서가 없습니다.</div>;

    return (
        <div className={`section ${className}`}>
            <div className="book_list">
                <ul className="clear">
                    {bookListElement}
                </ul>
            </div>
        </div>
    );
}